const styles = {
  ratingNumber: {
    color: 'text.primaryDark',
    fontWeight: '600!important',
    lineHeight: '12px!important',
    fontSize: '18px!important',
    textAlign: 'center',
    mt: '5px',
    display: 'flex',
    flexDirection: 'column',
  },
  rating: {
    fontSize: 7,
  },
}

export default styles
